/* eslint-disable camelcase */
import React from 'react';
import { appraiseLogo } from '../images';
import axios from 'axios';
import { BASE_URL } from '../Config';
import Toast from '@applane/react-toast';
import { useState, useEffect } from 'react';
import { getAppraisalRecordURI } from '../Queries/dealer';

export default () => {

  const { pathname } = typeof window !== undefined ? window.location : { pathname: '/' };
  const pathSegments = pathname.split('/');
  const appraisalId = pathSegments[pathSegments.length - 1];
  
  console.log('appraisalId', appraisalId)

  const [data, setData] = useState('')


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/invoke`, {
          paramValue: {
            appraisalId
          },
          id: 'interestedAppraisal'
        });

        setData(response.data.response.result);

      } catch (error) {
        // Handle error
        console.error('Error saving data:', error);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this will only run once when the component mounts

  console.log('data', data)
  
  const logo = !data?.dealer?.dealerLogo ? 'https://images.groovetech.io/1SGHmjpC5Swx-sf9jnapDnwfPt2_pKQ6FyjuxIvu9AE/rs:fit:0:0:0/g:no:0:0/c:0:0/aHR0cHM6Ly9hc3NldHMuZ3Jvb3ZlYXBwcy5jb20vaW1hZ2VzLzRkNTRmNTQ3LTA3MDktNGY1MS04N2FkLTQwMTE4NGQ4Yjg5ZS8xNzA2NDcwNjgxX2ljb250cmFuc3BhcmVudC5wbmc.webp' : data?.dealer?.dealerLogo.startsWith("http") ? data?.dealer?.dealerLogo : `${BASE_URL}/dealerLogo/${data?.dealer?.dealerLogo}`


  return (
    <main
      style={{
        alignItems: "center",
        backgroundColor: "#F7FAFC",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        minHeight: "100vh",
        paddingTop: "15rem",
        paddingBottom: "3rem",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          width: "100%",
          textAlign: "center",

        }}
      >
        <div>
          <div style={{
            marginBottom: "6rem"
          }}>
            
            <img
              alt="Company Logo"
              src={logo}
              style={{
                width: '200px',
                height: '200px',
                background: 'black',

              }}
            />
          </div>
          <h2
            style={{
              color: "#1A202C",
              fontSize: "3rem",
              fontWeight: "800",
              marginTop: "3rem",
              textAlign: "center",
            }}
          >
            Thank you for your interest!
          </h2>
          <p
            style={{
              color: "#718096",
              fontSize: "2rem",
              marginTop: "2.5rem",
              textAlign: "center",
            }}
          >
            {data?.dealer?.interestContent}
          </p>
        </div>

      </div>
    </main>
  )
};
